import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-planner"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("path", {
        d: "M34.9994 32.4835V14.1938C34.9994 13.6416 34.5517 13.1938 33.9994 13.1938H21.156C20.8908 13.1938 20.6365 13.0885 20.4489 12.9009L19.3573 11.8094C19.1698 11.6218 18.9155 11.5165 18.6502 11.5165H13.355C12.8027 11.5165 12.355 11.9642 12.355 12.5165V16.5486",
        class: "icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M9.12695 17.1499C9.06152 16.8391 9.29864 16.5469 9.61622 16.5469H30.8327C31.3057 16.5469 31.7124 16.8705 31.8097 17.3334C32.4559 20.4076 34.7785 31.4565 34.8368 31.7243C34.9044 32.0354 35.0729 32.4818 34.9646 32.4818H13.1661C12.6932 32.4818 12.285 32.1506 12.1876 31.6878L9.12695 17.1499Z",
        class: "icon-fi--stroke-linecap-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }